import { render } from "./running.vue?vue&type=template&id=0583d71a&scoped=true"
import script from "./running.vue?vue&type=script&lang=js"
export * from "./running.vue?vue&type=script&lang=js"

import "./running.vue?vue&type=style&index=0&id=0583d71a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0583d71a"]])

export default __exports__